// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffportal/v1/report_model.proto (package bffportal.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffportal/v1/report_model.proto.
 */
export const file_bffportal_v1_report_model: GenFile = /*@__PURE__*/
  fileDesc("Ch9iZmZwb3J0YWwvdjEvcmVwb3J0X21vZGVsLnByb3RvEgxiZmZwb3J0YWwudjEiPAoIRnJhbWVLd2gSDQoFZnJhbWUYASABKAUSIQoDa3doGAIgASgLMhQuZ29vZ2xlLnR5cGUuRGVjaW1hbELBAQoQY29tLmJmZnBvcnRhbC52MUIQUmVwb3J0TW9kZWxQcm90b1ABWkpnaXRodWIuY29tL2VuZWNoYWluL2Vwb3NpdGlvbi1hcHAvYmFja2VuZC9nZW4vcHJvdG8vYmZmcG9ydGFsL3YxO2JmZnBvcnRhbKICA0JYWKoCDEJmZnBvcnRhbC5WMcoCDEJmZnBvcnRhbFxWMeICGEJmZnBvcnRhbFxWMVxHUEJNZXRhZGF0YeoCDUJmZnBvcnRhbDo6VjFiBnByb3RvMw", [file_google_type_decimal]);

/**
 * @generated from message bffportal.v1.FrameKwh
 */
export type FrameKwh = Message<"bffportal.v1.FrameKwh"> & {
  /**
   * @generated from field: int32 frame = 1;
   */
  frame: number;

  /**
   * @generated from field: google.type.Decimal kwh = 2;
   */
  kwh?: Decimal;
};

/**
 * Describes the message bffportal.v1.FrameKwh.
 * Use `create(FrameKwhSchema)` to create a new message.
 */
export const FrameKwhSchema: GenMessage<FrameKwh> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_report_model, 0);

